import React, { useState } from 'react'
import {
    Autocomplete,
    Backdrop,
    Box,
    Button,
    CircularProgress,
    Grid,
    MenuItem,
    TextField,
    Snackbar,
    Alert
} from "@mui/material";

import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { VisibilityOff, Visibility, Close } from '@mui/icons-material';

import regex from "../../regex.json"

import axios from "axios";
import config from "../../config.json"

import { Routes, Route, useNavigate, Navigate, useParams } from "react-router-dom";

import profile from '../../assets/nirbi.png'
import rmrc from '../../assets/rmrc.png'
import Footer from '../Footer'

import { toast, ToastContainer } from "react-toastify";

import { useDispatch } from 'react-redux';
import { setAuthToken } from '../redux/actions';
import { disableBackButton } from '../ConstantComponents/Constants'


const BASE_URL = config.SERVER_URL;

const TITLE = config.TITLE;
const SECRET = config.SECRET;
export default function StrainRepositoryLogin() {

    disableBackButton()

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const [backdropopen, setbackdropopen] = useState(false);

    const [isLogin, setisLogin] = useState(false)


    const [showPassword, setshowPassword] = useState(false)

    const [email, setemail] = useState("")
    const [erremailb, seterremailb] = useState(false)
    const [erremail, seterremail] = useState("")

    const [password, setpassword] = useState("")
    const [errpasswordb, seterrpasswordb] = useState(false)
    const [errpassowrd, seterrpassowrd] = useState("")

    const [snackopen, setsnackopen] = useState(false)
    const [snackmessage, setsnackmessage] = useState('')
    const [snacklevel, setsnacklevel] = useState('success')

    const style2 = {
        position: 'absolute',
        left: '50%',
        top: '50%',
        width: 'auto',
        maxHeight: '100vh',
        transform: 'translate(-50%, -50%)',
        overflowY: 'auto',
        margin: 'auto',
        marginTop: 5,
        display: "flex",
        flexDirection: "row",
        border: "1px solid",
        padding: "20px",
        borderRadius: '20px',


    }

    const handleClickShowPassword = () => {
        if (showPassword === false) {

            setshowPassword(true)

        } else {

            setshowPassword(false)

        }
    }

    const handleSnackClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setsnackopen(false)
    }

    const handleloginClick = async () => {

        const params = new URLSearchParams();

        params.append("email", email);
        params.append("password", password)

        if (validation()) {

            setbackdropopen(true)

            //////console.log("login clicked")

            axios.post(BASE_URL+"/auth/login",
                params, { withCredentials: true }
            )
                .then(response => {
                    ////console.log("login", response);
                    //////console.log("headers", response.headers);
                    //////console.log("cust header", response.headers.authtoken);
                    if (response.status == 200) {

                        if (response.data.status == true) {
                            setbackdropopen(false)
                            sessionStorage.setItem('sessionid', response.headers.authtoken);
                            //dispatch(setAuthToken(response.headers.authtoken));
                            navigate(response.data.redirectview.url)
                            navigate("/straindashboard")
                        } else {
                            setsnacklevel("error")
                            setsnackopen(true)
                            setbackdropopen(false)
                            setsnackmessage(response.data.message)
                        }


                    } else {

                        setsnacklevel("error")
                        setsnackmessage("Error While Loggin In")
                        setsnackopen(true)
                        setbackdropopen(false)
                    }

                })
                .catch(error => {

                    setsnacklevel("error")
                    setsnackmessage("Error While Loggin In")
                    setsnackopen(true)
                    setbackdropopen(false)
                });

        }




    }

    function validation() {
        let isValid = true;

        if (email === "") {
            seterremailb(true)
            seterremail("Please Enter Email")
            isValid = false;
        } else if (!email.match(regex.emailpattern)) {
            seterremailb(true)
            seterremail("Please Enter Valid Email")
            isValid = false;
        } else {
            seterremailb(false)
            seterremail("")
        }

        if (password === "") {
            seterrpasswordb(true)
            seterrpassowrd("Please Enter Password")
            isValid = false;
        } else {
            seterrpasswordb(false)
            seterrpassowrd("")
        }

        return isValid;

    }



    return (
        <>
            <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Box
                    sx={style2}
                    noValidate
                    autoComplete="off"
                >
                    <Grid container spacing={1} sx={{ padding: 5, alignItems: 'center', display: 'flex', flexShrink: '1' }}>
                        <div className="container" style={{
                            textAlign: 'center', marginBottom: '15px', alignItems: 'center',
                            justifyContent: 'center', display: 'flex', flexWrap: 'wrap'
                        }}>
                            {/* <h4 className="rubik-font"
                                style={{ color: "black", fontWeight: "lighter", textAlign: 'center' }}> ICMR STRAIN REPOSITORY</h4> */}

                            <img src={profile} style={{ width: '100%', alignItems: "center" }}></img>
                            {/*<img src={rmrc} style={{ width: '100%', alignItems: "center" }}></img>*/}
                        </div>

                    </Grid>

                    <Grid sx={{ border: '1px solid' }} />

                    <Grid container spacing={1} sx={{ padding: 5 }}>
                        <div className="container" style={{ textAlign: 'center', marginBottom: '15px' }}>
                            <h4 className="rubik-font"
                                style={{ color: "black", fontWeight: "lighter", textAlign: 'center' }}> Login</h4>
                        </div>
                        <Grid item xs={12} md={12} lg={12} >
                            <div>
                                <TextField
                                    error={erremailb}
                                    helperText={erremail}
                                    fullWidth
                                    label="Email"
                                    value={email}
                                    onChange={
                                        (e) => setemail(e.target.value)
                                        //setdistrict(centers.filter(op => op.center_dist_id === district))
                                    }

                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12} sx={{ marginTop: 5 }}>
                            <div>
                                <TextField
                                    error={errpasswordb}
                                    helperText={errpassowrd}
                                    fullWidth
                                    label="Password"
                                    value={password}
                                    type={showPassword ? 'text' : 'password'}
                                    onChange={
                                        (e) => setpassword(e.target.value)
                                        //setdistrict(centers.filter(op => op.center_dist_id === district))
                                    }
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    //onMouseDown={handleMouseDownPassword}
                                                    edge="end"
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}


                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12} sx={{ marginTop: 5, alignItems: 'center', justifyContent: 'center', display: 'grid' }}>
                            <Button variant="contained" onClick={handleloginClick}>Login</Button>

                        </Grid>
                    </Grid>
                </Box>
            </div>
            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={snackopen} autoHideDuration={6000} onClose={handleSnackClose}>
                <Alert

                    onClose={handleSnackClose}
                    severity={snacklevel}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {snackmessage}
                </Alert>
            </Snackbar>

            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={backdropopen}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

        </>
    )
}
